/** 报名记录路由 */
export default {
    name: 'application',
    path: 'application',
    meta: {
        title: '报名记录'
    },
    component: ()=>import('@/pages/application/application.vue'),
    children: []
}